import { parseDatetime, parseTime as parseTimeHelper } from "lib/date";

export const getVisibleOffices = (state, category) => {
	return Object.values(state).filter(
		(office) => office.category && office.category.slug === category
	);
};

export const getAllOfficesFormatted = (state) => {
	return Object.values(state);
};

export const selectOffice = (offices, id) => {
	if (!id) return null;
	return offices.bySlug[id];
};

export const selectOfficeHours = (officeHours, id, date, timezone) => {
	if (!timezone) return [];
	if (!id) return [];
	if (!officeHours.byId[id]) return [];
	const parseTime = parseTimeHelper(date, timezone);
	return officeHours.byId[id]
		.filter(
			(oh) => Number(oh.weekday) === date.weekday() + 1 && oh.reservable
		)
		.map((oh) => ({ from: parseTime(oh.from), to: parseTime(oh.to) }));
};

export const selectOfficeReservations = (reservations, id) => {
	if (!id) return [];
	if (!reservations.byId[id]) return [];
	return reservations.byId[id].map((r) => ({
		from: parseDatetime(r.from),
		to: parseDatetime(r.to),
	}));
};

export const selectLineReservations = (reservations, id) => {
	if (!id) return [];
	return Object.values(reservations.byId)
		.filter((r) => r.line_id === id)
		.map((r) => ({
			from: parseDatetime(r.from),
			to: parseDatetime(r.to),
		}));
};

export const selectIsOfficeLoadingHack = (offices) =>
	Object.values(offices) === 0;

export const selectCategoryBySlug = (categories, slug) => {
	return Object.values(categories.byId).reduce(
		(def, cat) => (cat.slug === slug ? cat : def),
		null
	);
};
